// extracted by mini-css-extract-plugin
export var logo = "_ba-2";
export var logoWrapper = "_ba-1";
export var strip = "_ba-0";